import React from 'react';
import FiltersModal from '../../../components/filters_modal';
import EnrolledSequencesReportFilters from './enrolled_sequences_report_filters';

const EnrolledSequencesReportFiltersModal = ({
  modalInstance,
  initialFilters,
  humanizedTypes,
  triggers,
  categories,
}) => (
  <FiltersModal modalInstance={modalInstance} initialFilters={initialFilters}>
    {({ setFilters }) => (
      <EnrolledSequencesReportFilters
        initialFilters={initialFilters}
        onChange={setFilters}
        humanizedTypes={humanizedTypes}
        triggers={triggers}
        categories={categories}
        inModal
      />
    )}
  </FiltersModal>
);

angular
  .module('gym')
  .value('EnrolledSequencesReportFiltersModal', EnrolledSequencesReportFiltersModal);
